<template>
    <div class="modal" v-show="value">
        <div class="modal__content modal__content__big">
            <div class="modal__header">
                <div class="modal__header-title text-light">
                    <span>{{ $t('common.modal.customer.title') }}</span>
                </div>
            </div>
            <div class="modal__body">
                <div id="signaturePad">
                    <canvas id="signatureCanvas"></canvas>
                </div>
            </div>
            <div class="modal__footer">
                <div class="modal__footer__buttons">
                    <button type="button" v-if="!loading" class="btn btn__danger" @click="close()">{{ $t('common.abort') }}</button>
                    <button type="button" v-if="!loading" class="btn" @click="confirm()">{{ $t('common.sign') }}</button>
                    <span v-if="loading">{{ $t('common.loading') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import signPad from 'signature_pad/dist/signature_pad';

    export default {
        name: 'signature-pad',
        props: {
            value: {
                required: true
            }
        },
        data() {
            return {
                canvas: null,
                signaturePad: null,
                loading: false
            }
        },
        mounted() {
            this.canvas = document.getElementById("signatureCanvas");
        },
        methods: {
            init() {
                this.signaturePad = new signPad(this.canvas, {
                    minWidth: 3,
                    maxWidth: 3,
                    penColor: 'black'
                });
                var ratio = Math.max(window.devicePixelRatio || 1, 1);
                this.canvas.width = this.canvas.offsetWidth * ratio;
                this.canvas.height = this.canvas.offsetHeight * ratio;
                this.canvas.getContext("2d").scale(ratio, ratio);
            },
            confirm() {
                // resize dell'immagine
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                let ratioResize = 3.7;
                let w = this.canvas.width / ratioResize;
                let h = this.canvas.height / ratioResize;
                canvas.width = w;
                canvas.height = h;

                var image = new Image();
                this.loading = true;
                image.onload = () => {
                    ctx.drawImage(image, 0, 0, w, h);
                    this.loading = false;
                    this.$emit("result", canvas.toDataURL('image/png', 0.4));
                    this.$emit("input", !this.value);
                };
                image.src = this.signaturePad.toDataURL('image/png');
            },
            close() {
                this.$emit("result", false);
                this.$emit("input", !this.value);
            }
        },
        watch: {
            value: {
                handler(val) {
                    if(val) {
                        setTimeout(() => {
                            this.init();
                        }, 10);

                    }
                },
                deep: true
            }
        }
    };
</script>
<style lang="scss">
    #signaturePad {
        width: 100%;
        border: 1px solid #efefef;
        margin: 10px;

        canvas {
            width: 100%;
            min-height: 300px;
        }
    }
</style>
